export const MAX_RECORD_DURATION_MS = 60000;

export const getDevicesOfType = (types, devicesList) => {
  if (!types) return;

  const deviceTypes = Array.isArray(types) ? types : [types];
  return devicesList.filter((device) => deviceTypes.includes(device.device_type));
};

export function getDeviceOptions(connectedDevices, group) {
  const deviceList = getDevicesOfType(['Technology Bridge_Siren/Giant Voice'], connectedDevices);

  return deviceList
    .filter((device) => device?.camera)
    .map((device) => ({
      label: device.alias,
      name: device.alias,
      value: device.id,
      systemType: device.system_type || 'Unknown System',
      deviceType: device.device_type || 'Unknown Device Type',
      forceSelect: group,
    }));
}

export function filterOptions(options, searchValue) {
  const normalizedSearch = searchValue.trim().toLowerCase();
  if (!normalizedSearch) return options;

  return options.filter((option) =>
    `${option.label || ''} ${option.value || ''} ${option.systemType || ''} ${option.deviceType || ''}`
      .toLowerCase()
      .includes(normalizedSearch),
  );
}

export function groupOptionsBySystemAndType(options, getSelectedCount) {
  const groups = new Map();

  options.forEach((option) => {
    const systemKey = option.systemType || 'Unknown System';
    const typeKey = option.deviceType || 'Unknown Device Type';
    if (!groups.has(systemKey)) groups.set(systemKey, new Map());
    const systemGroup = groups.get(systemKey);
    if (!systemGroup.has(typeKey)) systemGroup.set(typeKey, []);
    systemGroup.get(typeKey).push(option);
  });

  return Array.from(groups.entries()).map(([systemType, deviceTypes]) => ({
    id: systemType,
    label: systemType,
    sections: Array.from(deviceTypes.entries()).map(([deviceType, items]) => ({
      id: `${systemType}::${deviceType}`,
      label: deviceType,
      items,
      selectedCount: getSelectedCount(items),
    })),
  }));
}

export function getCurrentAssociatedAudioIdsForDevice(audioList, deviceId) {
  return audioList
    .filter(
      (audio) =>
        Array.isArray(audio.device_ids) && audio.device_ids.some((id) => `${id}` === `${deviceId}`),
    )
    .map((audio) => audio.id);
}
